import React from "react";

const PALETTE = ["#5B7CFF", "#8B5CF6", "#EC4899", "#F59E0B", "#10B981", "#06B6D4", "#EF4444"];

function colorForName(name = "") {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return PALETTE[Math.abs(hash) % PALETTE.length];
}

export default function Avatar({ name, src, size = 80 }) {
  const initials =
    name?.split(" ").map((n) => n[0]).slice(0, 2).join("").toUpperCase() || "?";
  const bg = colorForName(name);

  return (
    <div
      className="flex shrink-0 items-center justify-center overflow-hidden rounded-full ring-2 ring-white shadow-sm"
      style={{ width: size, height: size, backgroundColor: src ? "transparent" : `${bg}22` }}
    >
      {src ? (
        <img src={src} alt={name} className="h-full w-full object-cover" />
      ) : (
        <span style={{ color: bg, fontSize: size * 0.36 }} className="font-semibold">
          {initials}
        </span>
      )}
    </div>
  );
}